import { LessonContent, LessonModal, LessonSheet } from "@/components/lesson";
import { useIsMobile } from "@/lib/useDeviceType";
import type { Lesson, UserLesson } from "@/types";
import React from "react";

type LessonPreviewProps = {
  lesson: Lesson | null;
  sheetOpen: boolean;
  modalOpen: boolean;
  onSheetChange: (open: boolean) => void;
  onModalChange: (open: boolean) => void;
  onPlayPress: () => void;
  userLessonsMap: Record<number, UserLesson>;
  courseSlug: string;
  userId?: string;
  hidePublishedDate?: boolean;
  showError: (msg: string) => void;
  showSuccess: (msg: string) => void;
  isAnon?: boolean;
  collectionId?: number;
  referrer?: string;
  referrerTitle?: string;
  courseTitle?: string;
};

export function LessonPreview({
  lesson,
  sheetOpen,
  modalOpen,
  onSheetChange,
  onModalChange,
  onPlayPress,
  userLessonsMap,
  courseSlug,
  userId,
  hidePublishedDate = false,
  showError,
  showSuccess,
  isAnon = false,
  collectionId,
  referrer,
  referrerTitle,
  courseTitle,
}: LessonPreviewProps) {
  const isMobile = useIsMobile();
  const isCompleted = lesson
    ? userLessonsMap[lesson.id]?.is_completed || false
    : false;
  const dismiss = () => {
    onSheetChange(false);
    onModalChange(false);
  };

  return (
    <>
      <LessonSheet
        open={isMobile && sheetOpen}
        onOpenChange={(open) => {
          if (open === sheetOpen) return;
          onSheetChange(open);
          if (open) onModalChange(false);
        }}
      >
        <LessonContent
          isWeb={false}
          lesson={lesson}
          onPlayPress={onPlayPress}
          onBookmarkIconPress={dismiss}
          showError={showError}
          showSuccess={showSuccess}
          userId={userId}
          courseSlug={courseSlug}
          isCompleted={isCompleted}
          hidePublishedDate={hidePublishedDate}
          isAnon={isAnon}
          collectionId={collectionId}
          referrer={referrer}
          referrerTitle={referrerTitle}
          courseTitle={courseTitle}
        />
      </LessonSheet>
      <LessonModal
        open={!isMobile && modalOpen}
        onOpenChange={(open) => {
          if (open === modalOpen) return;
          onModalChange(open);
          if (open) onSheetChange(false);
        }}
      >
        <LessonContent
          lesson={lesson}
          isWeb={true}
          onPlayPress={onPlayPress}
          onBookmarkIconPress={dismiss}
          showError={showError}
          showSuccess={showSuccess}
          userId={userId}
          courseSlug={courseSlug}
          isCompleted={isCompleted}
          hidePublishedDate={hidePublishedDate}
          isAnon={isAnon}
          collectionId={collectionId}
          referrer={referrer}
          referrerTitle={referrerTitle}
          courseTitle={courseTitle}
        />
      </LessonModal>
    </>
  );
}
